function resizeWindow(){

}
var executed = false;

function scrollDown(){
    // if( executed == false){
    //     $(".booking-btn").find("span").animate({opacity: 0}, 400, function () {
    //         $(".booking-btn").removeClass("active");
    //         $(".booking-btn").html("<span>BOOK NOW</span>");
    //         $(".booking-btn").animate({opacity: 1}, function () {
    //             //$(this).closest("a").next("form").slideUp();
    //         });
    //         $(".booking-wrapper").find("form").animate({right: "-100%", opacity: 0}, 600, function(){
    //             $(this).css("display", "none");
    //         });
    //     });
    //     $(".menu-wrapper").removeClass("active");
    //     executed = true;
    // }
    // return executed;
}

function fadeInHeadline(){
    $(".top-content .v-center").fadeIn();
}

$(document).ready(function () {

	//Put the Heading in Center
	equalize(fadeInHeadline);
	setTimeout(function(){
		$("body").addClass("loaded");
	}, 800);


	//Call function with browser is resized.
    $(window).resize(function (event) {
         resizeWindow();
    });
    resizeWindow();

    //Acts when scroll down page.
    $(window).scroll(function (event) {
    	scrollDown();
		var top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	});

    // Main Nav Dropdown
    $("#primary-nav li").hover(function(){

        $(this).addClass("hover");
        $('ul.submenu',this).slideDown(400);

    }, function(){

        $(this).removeClass("hover");
        $('ul.submenu',this).slideUp(400);

    });

	
	//Slick Slider
	$('.sym-slides').slick();
	
	$('.rooms-expand').slick();
	
	$('.map-pins').slick({
		asNavFor: ".map-images"
	});
	
	$('.map-images').slick({
		asNavFor: ".map-pins",
	});

    $('a[data-slide]').click(function(e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        $('.map-images').slick('slickGoTo', slideno - 1);
        console.log(slideno);
    });

	$('.map-images').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		var activePin = $(slick.$slides[nextSlide]).attr('class').split(' ')[0];
		$(".map-container li").removeClass("active");
		$(".map-container li." + activePin).addClass("active");
		console.log(activePin);
	});
	
	//Toggle main navigation
	$("#header .menu-btn").on("click", function(){
		if($(".menu-wrapper").hasClass("active")){
			$(this).removeClass("active");
			$(this).find(".text").text("Menu");			
			$(this).find(".close").animate({opacity: 0}, 300, function(){
				$("#header .menu-btn .open").animate({opacity: 1}, 300);
			});
			$(".menu-wrapper").removeClass("active");
		} else {
			$(this).addClass("active");
			$(this).find(".text").text("Close");
			$(this).find(".open").animate({opacity: 0}, 300, function(){
				$("#header .menu-btn .close").animate({opacity: 1}, 300);
			});
			$(".menu-wrapper").addClass("active");
		}
		return false;
	});
	

	//Event Tracking
    $('.book-now').on('click', function () {
         ga('send', 'event', 'reservations', 'click', 'book now');
    });
    $('.bookNow').on('click', function () {
         ga('send', 'event', 'header widget', 'click', 'book now');
    });

	const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "M d, yy";
	let DATE_STYLE = [true];
	function calendarRange(date){			
		let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
		let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
		if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
			DATE_STYLE[1] = 'highlight-top';
		}else if(date > d1 && date < d2){
			DATE_STYLE[1] = 'highlight';
		}else{
			DATE_STYLE[1] = '';
		}
		return DATE_STYLE;
	}
	//Check in and check out datepicker for booking engine		
	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		dateFormat: "M d, yy",
		numberOfMonths: 1,
		onSelect: function( selectedDate ) {
			let getDate = $(this).datepicker('getDate');
			let newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 1);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut" ).datepicker({
		dateFormat: "M d, yy",
		changeMonth: true,
		numberOfMonths: 1,
		afterShow: function() {
			setTimeout(function() {
				document.querySelectorAll('#booking-form .form-entry input').forEach(e => {
					e.setAttribute('tabindex', '-1');
				})
			}, 1000);
		},
		onSelect: function(selectedDate) {
			// $( "#CheckIn" ).datepicker("option", "maxDate", selectedDate);
		}
	});

	$('#booking-form').on('submit',function(){
		let getDateIn = $( "#CheckIn" ).datepicker('getDate');
		let newDateIn = new Date(getDateIn.getTime());
		var month1 = newDateIn.getMonth() + 1;
		var day1 = newDateIn.getDate();
    	var year1 = newDateIn.getFullYear();
		let getDateOut = $( "#CheckOut" ).datepicker('getDate');
		let newDateOut = new Date(getDateOut.getTime());
		var month2 = newDateOut.getMonth() + 1;
		var day2 = newDateOut.getDate();
    	var year2 = newDateOut.getFullYear();
		var auxIn = $( "#CheckIn" ).val();
		var auxOut = $( "#CheckOut" ).val();
		$( "#CheckIn" ).val(year1+'-'+month1+'-'+day1);
		$( "#CheckOut" ).val(year2+'-'+month2+'-'+day2);
		setTimeout(function(){
			$( "#CheckIn" ).val(auxIn);
			$( "#CheckOut" ).val(auxOut);
		},200)
	});



	$('.js-open-booking').click(function(){
		$('.booking-form-block').addClass('show');
	})

	$('.js-close-booking').click(function(){
		$('.booking-form-block').removeClass('show');
	})
	
	/* ON SUBMIT */
	// $('#home .home-specials .booking-form').on("click", function(){
	// 	var promo = $(this).closest(".home-specials").find(".excerpt").data("promo");
	// 	$(this).find("input.promo").val(promo);
	// });
	
/*
	//Index Countdown
	var day = $('#day').val();
    var month = $('#month').val();
    var year = $('#year').val();
    var hour = $('#hour').val();
    var minute = $('#min').val();
    var second = $('#sec').val();
    setTimeout(function () {
        $('#countdown').countDown({
            targetDate: {
                'day': day,
                'month': month,
                'year': year,
                'hour': hour,
                'min': minute,
                'sec': second
            },
            omitWeeks: true
        });
    }, 800)
*/
	
});

/** ADA Function to modify Menu **/

document.addEventListener('DOMContentLoaded', () => {
	const skipSelectors = [
		'.booking-form-block__container .close-booking',
		'.booking-form-block__container .book-now',
		'#booking-form .form-entry #CheckOut',
		'#booking-form .form-entry #CheckIn'
	];


	skipSelectors.forEach(selector => {
		const elements = document.querySelectorAll(selector);
		if (elements.length > 0) {
			elements.forEach(element => {
				element.setAttribute('tabindex', '-1');
			});
		}
	});
});


/** ADA Tab Links Functionality for Keyboard Navigation **/

const navigationBox = document.querySelector('.booking-form-block__container');
const checkIn = document.querySelector('#CheckIn');
const checkOut = document.querySelector('#CheckOut');
const navBtn = document.querySelector('.book-now');
const bookingWidgetButton = document.querySelector('.js-open-booking');
const bookingCloseButton = document.querySelector('.js-close-booking');

function setTabIndex(value) {
    [bookingCloseButton, checkIn, checkOut, navBtn]
        .filter(el => el)
        .forEach(el => el.setAttribute('tabindex', value));
}

document.addEventListener('focusin', function (event) {
    setTabIndex(navigationBox.classList.contains('open') || !navigationBox.contains(event.target) ? 0 : -1);
});

if (bookingWidgetButton) {
    bookingWidgetButton.addEventListener('click', () => {
        navigationBox.classList.add('open');
        setTabIndex(0);
    });
}

if (bookingCloseButton) {
    bookingCloseButton.addEventListener('click', () => {
        navigationBox.classList.remove('open');
        setTabIndex(-1);
    });
}